var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8174 59.7622C32.8174 59.3653 32.4956 59.0435 32.0986 59.0435C31.7017 59.0435 31.3799 59.3653 31.3799 59.7622C31.3799 60.1592 31.7017 60.481 32.0986 60.481C32.4956 60.481 32.8174 60.1592 32.8174 59.7622Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1924 59.7622C47.1924 59.3653 46.8706 59.0435 46.4736 59.0435C46.0767 59.0435 45.7549 59.3653 45.7549 59.7622C45.7549 60.1592 46.0767 60.481 46.4736 60.481C46.8706 60.481 47.1924 60.1592 47.1924 59.7622Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 54.6562H47.5152C48.9175 54.6564 50.1154 53.6448 50.35 52.2623L55.4043 22.554C55.6397 21.1722 56.8373 20.1617 58.239 20.162H60.125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5836 24.6949L31.8369 22.715C30.3137 22.2687 28.7171 23.1413 28.27 24.6642L27.0625 28.7812M50.0721 28.7812L44.3221 23.0312C43.1994 21.9089 41.3795 21.9089 40.2568 23.0312L34.5068 28.7812H50.0721Z",
    stroke: "#228800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4097 46.0312H28.2736C25.6357 46.0309 23.3363 44.2357 22.6961 41.6766L19.917 30.5599C19.8095 30.1303 19.9061 29.6752 20.1786 29.3262C20.4512 28.9772 20.8695 28.7733 21.3123 28.7736H54.3441",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon2);
export default __webpack_public_path__ + "assets/media/cart-icon-2.d58c1c11af1b501e8286641ea751b271.svg";
export { ForwardRef as ReactComponent };